import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index'
import Certification from '@/page/Certification'
import Account from '@/page/Account'
import Money from '@/page/Money'
import Integral from '@/page/Integral'
import Searchpage from "../page/Searchpage"

import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(Router)
Vue.use(Vant)
export default new Router({
  mode: "hash",
  routes: [
    {
      path: '/',
      name: 'Index',
      component: resolve => { require(['../page/Index'], resolve) },
      meta: { title: "帮助反馈" }
    },

    {
      path: '/certification',
      name: 'Certification',
      component: resolve => { require(['../page/Certification'], resolve) },
      meta: { title: "认证问题" }
    },

    {
      path: '/account',
      name: 'Account',
      component: resolve => { require(['../page/Account'], resolve) },
      meta: { title: "账号问题" }
    },

    {
      path: '/integral',
      name: 'Integral',
      component: resolve => { require(['../page/Integral'], resolve) },
      meta: { title: "积分问题" }
    },

    {
      path: '/money',
      name: 'Money',
      component: resolve => { require(['../page/Money'], resolve) },
      meta: { title: "金币问题" }
    },

    {
      path: '/searchpage',
      name: 'searchpage',
      component: resolve => { require(['../page/Searchpage'], resolve) },
      meta: { title: "查询问题" }
    },
    {
      path: '/newindex',
      name: 'NewIndex',
      component: resolve => { require(['../page/NewIndex'], resolve) },
      meta: { title: "帮助与反馈" }
    }
    // ,
    // {
    //   path: '/complaint',
    //   name: 'complaint',
    //   component: resolve => { require(['../page/Complaint'], resolve) },
    //   meta: { title: "投诉建议" }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js